import { authMiddleware, timeoutMiddleware } from "@eisox/api";
import {
  createAccountRepository,
  createAirHandlerUnitRepository,
  createAlarmRepository,
  createAuthRepository,
  createBoilerRoomRepository,
  createBuildingRepository,
  createCoreApiClient,
  createEquipmentRepository,
  createFloorRepository,
  createGatewayRepository,
  createGeocodingRepository,
  createGroupRepository,
  createHeatingNetworkRepository,
  createHistoryRepository,
  createMeshRepository,
  createMeterRepository,
  createModuleRepository,
  createMultisensorRepository,
  createPlanningRepository,
  createRoomRepository,
  createUserRepository,
  createValveRepository,
} from "@eisox/api/core-api";
import { sessionRevokedMiddleware } from "@eisox/auth";

import { authTokenStorage } from "~/utils/auth-token.utils";

const REQUEST_TIMEOUT_MS = 10_000;

const api = createCoreApiClient({
  baseUrl: import.meta.env.VITE_SERVER_URL,
  middleware: [
    authMiddleware({ getToken: authTokenStorage.get }),
    timeoutMiddleware(REQUEST_TIMEOUT_MS),
    sessionRevokedMiddleware,
  ],
});

export const accountApi = createAccountRepository(api);
export const airHandlerUnitApi = createAirHandlerUnitRepository(api);
export const alarmApi = createAlarmRepository(api);
export const authApi = createAuthRepository(api);
export const boilerRoomApi = createBoilerRoomRepository(api);
export const buildingApi = createBuildingRepository(api);
export const equipmentApi = createEquipmentRepository(api);
export const floorApi = createFloorRepository(api);
export const gatewayApi = createGatewayRepository(api);
export const geocodingApi = createGeocodingRepository(api);
export const groupApi = createGroupRepository(api);
export const heatingNetworkApi = createHeatingNetworkRepository(api);
export const historyApi = createHistoryRepository(api);
export const meshApi = createMeshRepository(api);
export const meterApi = createMeterRepository(api);
export const moduleApi = createModuleRepository(api);
export const multisensorApi = createMultisensorRepository(api);
export const planningApi = createPlanningRepository(api);
export const roomApi = createRoomRepository(api);
export const userApi = createUserRepository(api);
export const valveApi = createValveRepository(api);
